import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProductPage from "./page/ProductPage";
import LegalMentionsPage from "./page/LegalMentionsPage";
import ConfidentialityPage from "./page/ConfidentialityPage";
import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import { useEffect } from "react";
import { gtm_tracking_id, tracking_id } from "./utils/variables";

function App() {
  useEffect(() => {
    const isConsent = getCookieConsentValue();
    if (isConsent === "true") {
      handleAcceptCookie();
    }
  }, []);

  const handleAcceptCookie = () => {
    ReactGA.initialize(tracking_id);
    TagManager.initialize({ gtmId: gtm_tracking_id });
  };

  return (
    <div className="h-full">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ProductPage />} />
          <Route path="/mentionslegales" element={<LegalMentionsPage />} />
          <Route path="/confidentialite" element={<ConfidentialityPage />} />
        </Routes>
      </BrowserRouter>
      <CookieConsent
        enableDeclineButton
        onAccept={handleAcceptCookie}
        buttonText="Accepter"
        declineButtonText="Refuser"
        style={{
          background: "#FFFFFF",
          color: "var(--black)",
          margin: "1.5vh",
          boxSizing: "border-box",
          width: "auto",
          borderRadius: "1.5vh",
        }}
        buttonStyle={{
          padding: "1vh 2vh",
          borderRadius: "1vh",
          background: "#69AFCC",
          color: "#FFFFFF",
        }}
        declineButtonStyle={{
          padding: "1vh 2vh",
          borderRadius: "1vh",
          background: "#E98D46",
          color: "#FFFFFF",
        }}
      >
        Ce site utilise des cookies pour améliorer l'expérience utilisateur
      </CookieConsent>
    </div>
  );
}

export default App;
